import React from 'react';

import { BodyText } from '../../atoms';
import { Container } from './Tag.styles';

import { TagColor, TagSize } from './types';
import { Icon } from '@chargify/icons';

export type TagProps = {
  /**
   * Tag contents
   */
  label: string;
  /**
   * Tag color schema
   */
  color?: TagColor;
  /**
   * Component size
   */
  size?: TagSize;
  /**
   * Allows to set text behaviour when text overflows the tag.
   */
  overflow?: 'truncate' | 'break-word';
  /**
   * Max tag width
   */
  maxWidth?: number;
  /**
   * OnDelete callback
   */
  onDelete?: () => void;
};

/**
- Tag component used for categorizing and presenting status.
**/
const Tag = ({
  label,
  size = 'regular',
  color = 'primary',
  overflow,
  maxWidth,
  onDelete,
}: TagProps) => (
  <Container role="status" color={color} size={size} maxWidth={maxWidth}>
    <BodyText
      variant="body2"
      color="inherit"
      fontStyle="inherit"
      fontWeight="inherit"
      overflow={overflow}
    >
      {label}
    </BodyText>
    {onDelete && (
      <Icon
        fill={'inherit'}
        type={'close'}
        size={8}
        onClick={onDelete}
        aria-close-label="Delete this tag"
      />
    )}
  </Container>
);

export default Tag;
